import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { getContactPreferencesForFront } from '@interlayer/js/app/components/main/MarketingPreferences/helpers';
import {
    TUpdatePreferencesStepData,
    TUserDetailsStepData
} from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/types';
import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';
import {
    setAdditionalRetailUpgradeData,
    setRegistrationNameStep,
    setRetailUpgradeData } from '@interlayer/js/app/store/reducers/Registration/actions';
import { STEP_NAMES } from '@interlayer/js/app/store/reducers/Registration/constants';
import { useFetchUserDetails } from '@interlayer/js/hooks/user/hooks/useFetchUserDetails';

export const useUpdateRetailUpgradeData = () => {
    const dispatch = useDispatch();
    const fetchUserDetails = useFetchUserDetails();

    return useCallback(async () => {
        const {
            zip,
            city,
            state,
            address,
            phone,
            birthDate,
            cellphone = phone,
            addressDetails,
            contactPreferences
        } = await fetchUserDetails();

        dispatch(setAdditionalRetailUpgradeData({
            dateOfBirth: birthDate
        }));

        const preferences = getContactPreferencesForFront(contactPreferences) as TUpdatePreferencesStepData;
        dispatch(setRetailUpgradeData({
            stepName: STEP_NAMES.PREFERENCES_RETAIL_UPGRADE_STEP,
            data: preferences
        }));

        dispatch(setRetailUpgradeData({
            stepName: STEP_NAMES.ADDRESS_RETAIL_UPGRADE_STEP,
            data: {
                [VALIDATION_FIELDS.zip]: zip,
                [VALIDATION_FIELDS.city]: city,
                [VALIDATION_FIELDS.state]: state,
                [VALIDATION_FIELDS.phone]: cellphone,
                [VALIDATION_FIELDS.house]: addressDetails?.buildingNumber || address?.split(' ')[0],
                [VALIDATION_FIELDS.street]: addressDetails?.streetName || address
                    ?.split(' ')
                    .slice(1)
                    .join(' ')
            } as TUserDetailsStepData
        }));

        dispatch(setRegistrationNameStep(STEP_NAMES.PIN_RETAIL_UPGRADE_STEP));
    }, [dispatch, fetchUserDetails]);
};
